<template>
  <div class="account">
    <auth />
    <Divider dashed/>
    <info />
  </div>
</template>

<script>
import auth from "./cell/auth/index"
import info from "./cell/info/index"
export default {
  name: "Account",
  components: {
    auth,
    info
  }
}
</script>